document.addEventListener('DOMContentLoaded', () => {
  const roots = document.querySelectorAll('[data-mse-purchase]');
  if (!roots.length) return;

  const qs = (sel, ctx = document) => ctx.querySelector(sel);

  const mediaScript = qs('script[data-mse-variant-media]');
  const mediaMap = mediaScript ? JSON.parse(mediaScript.textContent || '{}') : {};

  roots.forEach((root) => {
    const scope =
      root.closest('.product__info-container') ||
      root.closest('.product') ||
      root.closest('section') ||
      document;

    const productFormEl =
      root.closest('product-form') ||
      qs('product-form', scope) ||
      qs('product-form');

    const form =
      (productFormEl && qs('form', productFormEl)) ||
      qs('form[action^="/cart/add"]', scope) ||
      qs('form[action^="/cart/add"]');

    if (!form) return;

    const variantInput = qs('input[name="id"]', form);
    if (!variantInput) return;

    const btnSingle = qs('[data-mode="single"]', root);
    const btnBundle = qs('[data-mode="bundle"]', root);

    // Buttons dürfen nicht submitten
    [btnSingle, btnBundle].forEach((b) => {
      if (b && b.tagName === 'BUTTON') b.type = 'button';
    });

    const imgSingle = qs('[data-img-single]', root);
    const imgBundle = qs('[data-img-bundle]', root);

    // sichtbares Qty Feld (Dawn)
    const visibleQty =
      qs('input.quantity__input', scope) ||
      qs('quantity-input input', scope) ||
      qs('input[name="quantity"]', scope);

    // Hidden quantity im FORM (für FormData)
    let hiddenQty = qs('input[name="quantity"]', form);
    if (!hiddenQty) {
      hiddenQty = document.createElement('input');
      hiddenQty.type = 'hidden';
      hiddenQty.name = 'quantity';
      hiddenQty.value = visibleQty?.value || '1';
      form.appendChild(hiddenQty);
    }

    const bundleQty = parseInt(root.getAttribute('data-bundle-qty') || '6', 10);
    const bundleFree = parseInt(root.getAttribute('data-bundle-free') || '1', 10);
    const bundleLabel = root.getAttribute('data-bundle-label') || '5+1';

    // Merkt sich die letzte Einzel-Menge (damit 2/3/4 Einzel möglich sind)
    let lastSingleQty = (() => {
      const v = parseInt(visibleQty?.value || hiddenQty.value || '1', 10);
      return Number.isFinite(v) && v > 0 ? v : 1;
    })();

    const getPropsWrap = () => {
      let wrap = qs('[data-mse-props]', form);
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.setAttribute('data-mse-props', '');
        wrap.style.display = 'none';
        form.appendChild(wrap);
      }
      return wrap;
    };

    const setProps = (mode) => {
      const wrap = getPropsWrap();
      wrap.innerHTML = '';

      const add = (name, value) => {
        const i = document.createElement('input');
        i.type = 'hidden';
        i.name = `properties[${name}]`;
        i.value = value;
        wrap.appendChild(i);
      };

      if (mode === 'bundle') {
        add('Kaufoption', `Sparset ${bundleLabel}`);
        add('Hinweis', `${bundleFree} gratis (Menge ${bundleQty})`);
      } else {
        add('Kaufoption', 'Einzel');
      }
    };

    const setQuantity = (qty) => {
      const v = String(qty);

      if (visibleQty && visibleQty.value !== v) {
        visibleQty.value = v;
        visibleQty.dispatchEvent(new Event('input', { bubbles: true }));
        visibleQty.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (hiddenQty.value !== v) {
        hiddenQty.value = v;
        hiddenQty.dispatchEvent(new Event('input', { bubbles: true }));
        hiddenQty.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };

    // Optional: Mengenfeld im Bundle-Modus sperren (damit Bundle immer fix bleibt)
    const lockQuantityUI = (locked) => {
      if (visibleQty) visibleQty.disabled = !!locked;

      const qtyComp = visibleQty?.closest('quantity-input');
      if (qtyComp) {
        const btns = qtyComp.querySelectorAll('button');
        btns.forEach((b) => (b.disabled = !!locked));
      }
    };

    const setMode = (mode) => {
      const isBundle = mode === 'bundle';

      btnSingle?.setAttribute('aria-pressed', isBundle ? 'false' : 'true');
      btnBundle?.setAttribute('aria-pressed', isBundle ? 'true' : 'false');

      if (isBundle) {
        // vorherige Einzelmenge merken (falls User 2/3/4 gewählt hat)
        const currentSingle = parseInt(visibleQty?.value || hiddenQty.value || '1', 10);
        if (Number.isFinite(currentSingle) && currentSingle > 0) lastSingleQty = currentSingle;

        lockQuantityUI(true);
        setQuantity(bundleQty);
      } else {
        lockQuantityUI(false);
        // Einzel: NICHT auf 1 zwingen -> letzte Einzelmenge wiederherstellen
        setQuantity(lastSingleQty);
      }

      setProps(mode);
    };

    const updateImages = () => {
      const vid = variantInput.value;
      if (!vid) return;

      const data = mediaMap[String(vid)] || {};

      if (imgSingle && data.single) imgSingle.src = data.single;

      const bundleSrc = data.bundle || data.single || '';
      if (imgBundle && bundleSrc) imgBundle.src = bundleSrc;
    };

    const bind = (btn, mode) => {
      if (!btn) return;
      btn.addEventListener('click', (e) => {
        if (btn.tagName === 'BUTTON' && btn.type !== 'button') e.preventDefault();
        setMode(mode);
      });
    };

    bind(btnSingle, 'single');
    bind(btnBundle, 'bundle');

    // Wenn User im Einzel-Modus die Menge ändert: merken
    const onQtyChange = () => {
      const isBundle = btnBundle?.getAttribute('aria-pressed') === 'true';
      if (isBundle) return;

      const v = parseInt(visibleQty?.value || hiddenQty.value || '1', 10);
      if (Number.isFinite(v) && v > 0) lastSingleQty = v;
      hiddenQty.value = String(lastSingleQty);
    };
    visibleQty?.addEventListener('input', onQtyChange);
    visibleQty?.addEventListener('change', onQtyChange);

    // Submit-Sicherheit: Bundle erzwingt bundleQty, Einzel lässt User-Wert
    form.addEventListener('submit', () => {
      const isBundle = btnBundle?.getAttribute('aria-pressed') === 'true';
      if (isBundle) {
        setQuantity(bundleQty);
      } else {
        const v = parseInt(visibleQty?.value || hiddenQty.value || String(lastSingleQty), 10);
        const safe = Number.isFinite(v) && v > 0 ? v : lastSingleQty;
        setQuantity(safe);
      }
    });

    // Variant-Wechsel: Bilder aktualisieren
    const obs = new MutationObserver(() => updateImages());
    obs.observe(variantInput, { attributes: true, attributeFilter: ['value'] });

    form.addEventListener('change', () => {
      updateImages();
    });

    // Init: wenn kein State gesetzt -> Einzel, aber Menge NICHT plattmachen
    const hasState =
      btnSingle?.getAttribute('aria-pressed') === 'true' ||
      btnBundle?.getAttribute('aria-pressed') === 'true';

    if (!hasState) {
      // Einzel als Default, Menge bleibt was im Input steht (normal 1)
      setMode('single');
    } else {
      // vorhandenen Zustand respektieren
      const isBundle = btnBundle?.getAttribute('aria-pressed') === 'true';
      setMode(isBundle ? 'bundle' : 'single');
    }

    updateImages();
  });
});